import React from 'react'
import Icon from '../misc/Icons'
import KeyboardKey from '../uiKit/KeyboardKey'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

class KeyboardShortcutHelpDrawerItem extends React.Component{
	
	render(){					
		const {children, desc} = this.props

		return(
			<div className='helpDrawer--keyboard-item'>
				<div className='helpDrawer--keyboard-item-right'>						
					<div className='helpDrawer--keyboard-item-desc'>
						{desc}
					</div>						
					<div className='helpDrawer--keyboard-item-shortcut'>
						{children}
					</div>
				</div>
			</div>
		)
	}
}


class KeyboardShortcutHelpDrawerDivider extends React.Component{
	
	render(){

		return(
			<div className='helpDrawer--keyboard-divider' />
		)
	}
}



class KeyboardShortcutHelpDrawer extends React.Component{
	
	render(){		
		
		const {isViewOnly} = this.props 

		const isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0

		return[				
					<div className='helpDrawer-header' onClick={this.props.closeKeyboardShortcutDrawer} key='header'>
						<div className='helpDrawer-header-left'>
							<div className='helpDrawer-header-left-top'>
								<div className='helpDrawer-header-title'>
									Keyboard Shortcuts
								</div>
							</div>
							<div className='helpDrawer-header-left-bottom' />							
						</div>
						<div className='helpDrawer-header-right'>
							<Icon name='close-small' />
						</div>
					</div>,
					<div className='helpDrawer-list' key='list'>							
						<PerfectScrollbar
					    option={{
					    		handlers:['click-rail', 'drag-thumb', 'wheel', 'touch'],
					    		suppressScrollX: true
					    	}}		    	
		    		>						

		    		{!isViewOnly && 
		    			<React.Fragment>		    			
								<KeyboardShortcutHelpDrawerItem 
									desc="New Question">
									<KeyboardKey enter />								
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerDivider />

								<KeyboardShortcutHelpDrawerItem 
									desc="Cut Question">
									<KeyboardKey ctrlcmd isMac={isMac} />											
									<KeyboardKey letter="X" />
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Copy Question">
									<KeyboardKey ctrlcmd isMac={isMac} />											
									<KeyboardKey letter="C" />
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Paste Question">
									<KeyboardKey ctrlcmd isMac={isMac} />												
									<KeyboardKey letter="V" />
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Duplicate Question">
									<KeyboardKey ctrlcmd isMac={isMac} />																			
									<KeyboardKey letter="D" />
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Delete Question">
									<KeyboardKey delete isMac={isMac} />								
								</KeyboardShortcutHelpDrawerItem>
								
								<KeyboardShortcutHelpDrawerDivider />

							</React.Fragment>

						}

						<KeyboardShortcutHelpDrawerItem 
							desc="Go to Previous Question">
							<KeyboardKey arrowUp />							
						</KeyboardShortcutHelpDrawerItem>

						<KeyboardShortcutHelpDrawerItem 
							desc="Go to Next Question">
							<KeyboardKey arrowDown />								
						</KeyboardShortcutHelpDrawerItem>

						<KeyboardShortcutHelpDrawerItem 
							desc="Go to First Question">
							<KeyboardKey shift />
							<KeyboardKey arrowUp />								
						</KeyboardShortcutHelpDrawerItem>

						<KeyboardShortcutHelpDrawerItem 
							desc="Go to Last Question">
							<KeyboardKey shift />
							<KeyboardKey arrowDown />					
						</KeyboardShortcutHelpDrawerItem>													

						{!isViewOnly && 
		    			<React.Fragment>		    											

								<KeyboardShortcutHelpDrawerDivider/>

								<KeyboardShortcutHelpDrawerItem 
									desc="Move Up">
									<KeyboardKey ctrlcmd isMac={isMac} />																	
									<KeyboardKey arrowUp />								
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Move Down">
									<KeyboardKey ctrlcmd isMac={isMac} />
									<KeyboardKey arrowDown />								
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Move to Beginning">
									<KeyboardKey ctrlcmd isMac={isMac} />								
									<KeyboardKey shift />
									<KeyboardKey arrowUp />								
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerItem 
									desc="Move to End">
									<KeyboardKey ctrlcmd isMac={isMac} />								
									<KeyboardKey shift />								
									<KeyboardKey arrowDown />								
								</KeyboardShortcutHelpDrawerItem>

								<KeyboardShortcutHelpDrawerDivider />	

							</React.Fragment>
						}

						</PerfectScrollbar>
					</div>
		]
	}
}

export default KeyboardShortcutHelpDrawer

